import { render, staticRenderFns } from "./TextHighlight.vue?vue&type=template&id=9ddc9880"
import script from "./TextHighlight.vue?vue&type=script&lang=js"
export * from "./TextHighlight.vue?vue&type=script&lang=js"
import style0 from "./TextHighlight.vue?vue&type=style&index=0&id=9ddc9880&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports